import React from 'react';
import MasterSchedule from './pages/masterSchedule';

export default function App() {
  return <MasterSchedule />;
}